const NAME_ABOUT = "about";
const NAME_CONTRIBUTIONS = "contributions";
const NAME_CONTACT = "contact";

export {
    NAME_ABOUT, NAME_CONTRIBUTIONS, NAME_CONTACT
}
